export class procesadores
{
    public id: number;
    public idAnt: number;
    public dsc: string;
    public valor: number;
}